<!-- 服役信息 -->
<template>
  <div class="register">
    <!-- 导航栏 -->
    <van-nav-bar title="填写服役信息" fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <!-- 头像上传 -->
    <div class="list-item">
      <div class="item-top">
        <span>*</span>
        上传退伍证或者入伍登记表
      </div>
    </div>
    <div style="height:2rem;">
      <van-uploader :after-read="afterRead" v-model="logoImg" :show-upload="upload" @delete="colse">
        <div class="add-img">
          <img src="@/assets/img/home/add.png" class="add" />
          <p>添加图片</p>
        </div>
      </van-uploader>
    </div>
    <!-- 人员类别 -->
    <div class="list-item">
      <div class="item-top">
        <!-- <span>*</span> -->
        人员类别
      </div>
      <input
        type="text"
        class="input"
        placeholder="请选择人员类别"
        readonly
        v-model="type"
        @click="types=true"
      />
    </div>
    <van-popup v-model="types" round position="bottom">
      <van-picker
        show-toolbar
        :columns="typeList"
        @cancel="types = false"
        @confirm="typeSelect"
        value-key="name"
      />
    </van-popup>
    <!-- 入伍时间 -->
    <div class="list-item">
      <div class="item-top">
        <!-- <span>*</span> -->
        入伍时间
      </div>
      <input
        type="text"
        class="input"
        placeholder="请选择入伍时间"
        readonly
        v-model="time"
        @click="times=true"
      />
    </div>
    <van-popup v-model="times" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="入伍时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="selectTime"
        @cancel="times=false"
      />
    </van-popup>
    <!-- 退伍时间 -->
    <div class="list-item">
      <div class="item-top">
        <!-- <span>*</span> -->
        退伍时间
      </div>
      <input
        type="text"
        class="input"
        placeholder="请选择退伍时间"
        readonly
        v-model="endTime"
        @click="endTimes=true"
      />
    </div>
    <van-popup v-model="endTimes" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="退伍时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="selectEndTime"
        @cancel="endTimes=false"
      />
    </van-popup>
    <div class="list-item">
      <div class="item-top">
        <!-- <span>*</span> -->
        入伍地点
      </div>
      <input type="text" class="input" placeholder="请填写入伍地点" v-model="address" />
    </div>
    <!-- 服役年限 -->
    <div class="list-item">
      <div class="item-top">
        <!-- <span>*</span> -->
        服役年限
      </div>
      <input type="text" class="input" placeholder="请选择服役年限" readonly v-model="serviceYear" />
    </div>
    <!--      @click="showPickers=true" <van-popup v-model="showPickers" round position="bottom">
      <van-picker
        title="服役年限"
        show-toolbar
        :columns="yearList"
        @confirm="serviceYears"
        @cancel="showPickers=false"
      />
    </van-popup>-->
    <!-- 优抚类型 -->
    <!-- <div class="list-item">
      <div class="item-top">

        优抚类型
      </div>
      <input
        type="text"
        class="input"
        placeholder="请选择优抚类型"
        v-model="preferentialType"
        @click="careData=true"
        readonly
      />
      <van-popup v-model="careData" round position="bottom">
        <van-picker
          title="优抚类型"
          show-toolbar
          :columns="careDataList"
          @confirm="careDataConfirm"
          @cancel="careData=false"
          value-key="name"
          @change="onChange"
        />
      </van-popup>
    </div>-->
    <!-- 是否烈士子女 -->
    <div class="list-item">
      <div class="item-top">
        <!-- <span>*</span> -->
        是否烈士子女
      </div>
      <van-radio-group v-model="radio" class="encrypt-right">
        <van-radio name="1">
          <span :class="radio==1?'checked':''">是</span>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
        <van-radio name="0">
          <span :class="radio==0?'checked':''">否</span>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
      </van-radio-group>
    </div>
    <!-- 是否优抚对象 -->
    <div class="list-item">
      <div class="item-top">
        <!-- <span>*</span> -->
        是否优抚对象
      </div>
      <van-radio-group v-model="perferType" class="encrypt-right">
        <van-radio name="1">
          <span :class="perferType==1?'checked':''">是</span>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
        <van-radio name="0">
          <span :class="perferType==0?'checked':''">否</span>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
      </van-radio-group>
    </div>
    <!-- 是否进藏 -->
    <div class="list-item">
      <div class="item-top">
        <!-- <span>*</span> -->
        是否进藏
      </div>
      <van-radio-group v-model="enterTibet" class="encrypt-right">
        <van-radio name="1">
          <span :class="enterTibet==1?'checked':''">是</span>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
        <van-radio name="0">
          <span :class="enterTibet==0?'checked':''">否</span>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
      </van-radio-group>
    </div>
    <!-- 按钮 -->
    <div class="login-btn">
      <van-button type="danger" @click="navLogin(0)">{{token==2?'保存':'下一步，设置登录密码'}}</van-button>
    </div>
    <div class="log-nav" @click="navLogin(1)">
      <span>已有账号</span>
      <span>去登录</span>
    </div>
    <div class="login-lianxi">
      <a href="tel:85711525">就业创业科联系电话：85711525</a>
    </div>
  </div>
</template>

<script>
import getFormat from "@/until/getFormatDate";
import {
  getPersonnelTypeData,
  getSpecialCareData,
  upLoad,
  updateRegisterInfo
} from "@/api/apiData";
import { Toast, Dialog } from "vant";
import { mapState, mapMutations } from "vuex";

export default {
  name: "soliderInfo",
  components: {},
  data() {
    return {
      radio: "-1", //烈士子女
      perferType: "-1", //优抚对象
      enterTibet: "-1", //进藏人员
      type: "", //人员类别
      activeIcon: require("@/assets/img/user/select.png"),
      inactiveIcon: require("@/assets/img/user/unselect.png"),
      types: false,
      typeList: ["士官", "军官", "班长"],
      minDate: new Date(1900, 0, 1), //入伍时间
      maxDate: new Date(),
      currentDate: new Date(),
      time: "",
      careData: false,
      careDataList: [
        {
          values: "",
          className: "column1"
        },
        {
          values: "",
          className: "column2"
        }
      ],
      typeId: "",
      times: false,
      endTime: "",
      endTimes: false,
      address: "", //入伍地点
      serviceYear: "", //服役年限
      showPickers: false,
      yearList: ["2年", "3年", "5年", "10年"],
      preferentialType: "", //优抚类型
      preferentialTypeId: "",
      moveIn: 0, //入驻时间
      dateNum: 0, //退伍时间
      logoImg: [],
      logo: [],
      upload: true //logo区域
    };
  },
  computed: {
    ...mapState(["userParams", "token","telphone","password"])
  },
  watch: {
    dateNum() {
      const that = this;
      let { dateNum, moveIn } = that;
      const year = new Date(moveIn).getFullYear();
      const years = new Date(dateNum).getFullYear();
      if (dateNum != 0 && moveIn != 0) {
        let date = years - year;
        that.serviceYear = Math.ceil(date);
      }
    },
    moveIn() {
      const that = this;
      let { dateNum, moveIn } = that;
      const year = new Date(moveIn).getFullYear();
      const years = new Date(dateNum).getFullYear();
      if (dateNum != 0 && moveIn != 0) {
        let date = years - year;
        that.serviceYear = Math.ceil(date);
      }
    }
  },
  methods: {
    ...mapMutations(["userRegister"]),
    //   返回上页
    goBack() {
      this.$router.back();
    },
    // 获取选择类的数据
    getCheckData() {
      const that = this;
      // 获取人员数据类型
      getPersonnelTypeData().then(res => {
        if (res.code == 1) {
          that.typeList = res.data;
        }
        that.getinfoMessage();
        that.getYfData("");
      });
    },
    // 获取数据
    getinfoMessage() {
      const that = this;
      if (that.userParams.length >= 20) {
        that.upload = false;
        that.logo[0] = that.userParams[10];
        that.logoImg[0] = { url: that.userParams[10] }; //logo
        // 人员类型
        that.typeList.forEach(item => {
          if (item.value == that.userParams[11]) {
            that.type = item.name;
            that.typeId = item.value;
          }
        });
      
        // 入伍时间
        that.time = that.userParams[12];
        that.endTime = that.userParams[13];
        // 入伍地点
        that.address = that.userParams[14];
        // 服役年限
        that.serviceYear = that.userParams[15];
        //烈士子女
        that.radio = that.userParams[17];
        // if (that.userParams[15] == 0) {
        //   that.radio = 2;
        // } else {
        //   that.radio = that.userParams[15];
        // }
        // 优抚对象
        that.perferType = that.userParams[18];
        // if (that.userParams[16] == 0) {
        //   that.perferType = 2;
        // } else {
        //   that.perferType = that.userParams[16];
        // }
        // 进藏
        that.enterTibet = that.userParams[19];
        // if (that.userParams[17] == 0) {
        //   that.enterTibet = 2;
        // } else {

        // }
      }
    },
    // logo上传成功后的回调函数
    afterRead(file) {
      this.upload = false;
      upLoad({ file: file.content }).then(res => {
       
        if (res.code == 1) {
          this.logo[0] = res.data.path; //logo
        } else {
          Toast(res.msg);
        }
      });
    },
    // 删除logo
    colse(file) {
     
      const that = this;
      that.logo[0] = "";
      this.upload = true;
    },
    //获取优抚数据类型数据
    getYfData() {
      const that = this;
      let careDataList = that.careDataList;
      getSpecialCareData({ parent_id: "" }).then(res => {
        if (res.code == 1) {
          that.careDataList[0].values = res.data;
          getSpecialCareData({
            parent_id: that.careDataList[0].values[0].special_care_catid
          }).then(result => {
            if (result.code == 1) {
              that.careDataList[1].values = result.data;
            }
          });
        }
      });
    },
    // 选择人员类型
    typeSelect(val) {
      this.types = false;
      this.type = val.name;
      this.typeId = val.value;
    },
    //   选择入伍时间
    selectTime(val) {
      const that = this;
      let date = getFormat(val, "yy-mm-ss");
      that.moveIn = new Date(val).getTime();
      if (that.dateNum != 0) {
        if (that.dateNum < that.moveIn) {
          Toast.fail({
            message: "入伍时间不能大于退伍时间",
            forbidClick: true
          });
          return;
        }
      }
      this.time = date;
      this.times = false;
    },
    // 选择退伍时间
    selectEndTime(val) {
      const that = this;
      let date = getFormat(val, "yy-mm-ss");
      that.dateNum = new Date(val).getTime();
      if (that.moveIn == 0) {
        Toast.fail({
          message: "请先选择入伍时间"
        });
        return;
      }
      if (that.dateNum < that.moveIn) {
        Toast.fail({
          message: "退伍时间不能小于入伍时间",
          forbidClick: true
        });
        return;
      }
      this.endTime = date;
      this.endTimes = false;
    },
    // 选择服役年限
    // serviceYears(val) {
    //   this.serviceYear = val;
    //   this.showPickers = false;
    // },
    // 选择优抚类型
    careDataConfirm(val) {
      if (val[1] != undefined) {
        this.preferentialTypeId = val[1].special_care_catid;
        this.preferentialType = val[1].name;
      } else {
        this.preferentialTypeId = val[0].special_care_catid;
        this.preferentialType = val[0].name;
      }
      this.careData = false;
    },
    onChange(picker, values) {
      const that = this;
      getSpecialCareData({
        parent_id: values[0].special_care_catid
      }).then(result => {
        //(result);
        if (result.code == 1) {
          that.careDataList[1].values = result.data;
        }
      });
    },
    //  去登录
    navLogin(val) {
      const that = this;
      let {
        logo,
        typeId,
        moveIn,
        dateNum,
        serviceYear,
        preferentialTypeId,
        radio,
        perferType,
        enterTibet,
        endTime,
        time,
        address
      } = that;
      // 注册设置密码
      if (val == 0) {
        if (logo[0]=='') {
          Toast.fail({
            message: "请上传退伍证或者入伍登记表照片",
            forbidClick: true
          });
          return;
        }
        // if (typeId === "") {
        //   Toast.fail({
        //     message: "请选择人员类型",
        //     forbidClick: true
        //   });
        //   return;
        // }
        // if (moveIn === 0) {
        //   Toast.fail({
        //     message: "请选择入伍时间",
        //     forbidClick: true
        //   });
        //   return;
        // }
        // if (dateNum === 0) {
        //   Toast.fail({
        //     message: "请选择退伍时间",
        //     forbidClick: true
        //   });
        //   return;
        // }
        // if (address.replace(/[, ]/g, "").length == 0) {
        //   Toast.fail({
        //     message: "请填写入伍地点",
        //     forbidClick: true
        //   });
        //   return;
        // }
        // if (preferentialTypeId === "") {
        //   Toast.fail({
        //     message: "请选择优抚类型",
        //     forbidClick: true
        //   });
        //   return;
        // }
        // if (perferType === "") {
        //   Toast.fail({
        //     message: "请选择是否优抚对象",
        //     forbidClick: true
        //   });
        //   return;
        // }
        // if (radio === "") {
        //   Toast.fail({
        //     message: "请选择是否烈士子女",
        //     forbidClick: true
        //   });
        //   return;
        // }

        // if (enterTibet === "") {
        //   Toast.fail({
        //     message: "请选择是否进藏",
        //     forbidClick: true
        //   });
        //   return;
        // }

        // if (radio == 2) {
        //   radio = 0;
        // }
        // if (perferType == 2) {
        //   perferType = 0;
        // }
        // if (enterTibet == 2) {
        //   enterTibet = 0;
        // }
        let obj = [
          logo,
          typeId,
          time,
          endTime,
          address,
          serviceYear,
          preferentialTypeId,
          radio,
          perferType,
          enterTibet
        ];
        if (that.token != 2) {
          let arr = that.userParams.concat(obj);
          this.userRegister(arr);
          this.$router.push({
            name: "setPassWord",
            query: {
              type: 0
            }
          });
        } else {
          let userParams = that.userParams;
          // 注册信息更新
          let obj = {
            username: that.telphone,
            password: that.password,
            avatar: userParams[0].toString(),
            fullname: userParams[1],
            sex: userParams[2],
            nation: userParams[3],
            politics_status: userParams[4],
            id_card: userParams[5],
            district: userParams[6],
            family_address: userParams[7],
            census_register: userParams[8],
            mobile: userParams[9],
            soldier_credential:logo[0],
            personnel_type:typeId,
            checkin_time: time,
            checkout_time:endTime,
            enlist_address: address,
            service_length: serviceYear,
            special_care_catid:'',
            is_martyr_children: radio,
            has_been_tibet:perferType,
            is_special_care:enterTibet
          };
          updateRegisterInfo(obj).then(res => {
         
            if (res.code == 1) {
              Dialog.alert({
                title: "提示",
                message: res.msg
              }).then(() => {
                this.$router.replace("/login/account");
              });
            } else {
              Toast.fail({
                message: res.msg,
                forbidClick: true
              });
            }
          });
        }
      } else {
        //   首页登录
        this.$router.replace("/login/account");
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.getCheckData();
    });
  },
  mounted() {
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    // window.addEventListener("beforeunload", e => {
    //   //(e);
    //   window.scrollTo(0, 0);
    // });
  }
};
</script>
<style lang='less' scoped>
.list-item {
  display: flex;
  flex-direction: column;
  padding: 0.3rem;
  .item-top {
    font-size: 0.3rem;
    font-weight: 600;
    span {
      color: red;
    }
  }
  .input {
    width: 100%;
    padding: 0.19rem 0;
    border-bottom: 0.01rem solid #dedede !important;
    font-size: 0.3rem;
    background: #fff;
  }
  .input::-webkit-input-placeholder {
    font-size: 0.24rem;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
  }
  .encrypt-right {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0.23rem 0;
    border-bottom: 0.01rem solid #dedede;
    span {
      font-size: 0.3rem;
      line-height: 0.45rem;
      color: #cccccc;
    }
  }

  /deep/.van-radio-group {
    display: flex;

    .van-radio {
      flex: 1;
      display: flex;
      align-items: center;
      .img-icon {
        width: 0.4rem;
        height: 0.4rem;
      }
      .van-radio__label {
        font-size: 0.3rem;
        line-height: 0.42rem;
        color: #cccccc;
      }
      .checked {
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
.van-uploader {
  left: 50%;
  transform: translateX(-50%);
}
.add-img {
  margin: 0.2rem 0 0 0.32rem;
  width: 1.48rem;
  height: 1.48rem;
  border-radius: 0.12rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 0.02rem dashed #e6e6e6;
  .add {
    width: 0.48rem;
    height: 0.48rem;
  }
  p {
    font-size: 0.22rem;

    font-weight: 400;
    line-height: 0.3rem;
    color: rgba(153, 153, 153, 1);
  }
}
.login-btn {
  width: 90%;
  margin: 0.9rem auto 0;
  .van-button {
    width: 100%;
    background: rgba(255, 67, 67, 1);
    border-radius: 0.08rem;
  }
}
.log-nav {
  margin: 0.4rem 5% 0.1rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  span:nth-child(2) {
    color: #ff4343;
    padding-left: 0.1rem;
  }
  span:nth-child(2)::after {
    content: "";
    display: block;
    width: 0.8rem;
    height: 1px;
    background: rgba(255, 67, 67, 1);
    margin-left: 1.1rem;
  }
}
.login-lianxi {
  font-size: 0.3rem;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 0.3rem 5% 0.5rem;
}
</style>